import type { ReactNode } from 'react'
import * as Mtds from '@mattilsynet/design/react'
import { useTranslation } from 'react-i18next'
import { classifyError, toSaveErrorMessage } from '../../utils/userErrorUtils'

type SaveErrorProps = {
  error: unknown
  action?: string
  conflictMessage?: string
  children?: ReactNode
}

export const SaveError = ({
  error,
  action,
  conflictMessage,
  children
}: SaveErrorProps) => {
  const { i18n } = useTranslation()
  if (error == null) return null
  const locale = i18n.language === 'en' ? 'en' : 'nb'
  return (
    <Mtds.Alert
      as='div'
      role='alert'
      data-color={
        classifyError(error).kind === 'conflict' ? 'warning' : 'danger'
      }
    >
      <p>{toSaveErrorMessage(error, action, { locale, conflictMessage })}</p>
      {children}
    </Mtds.Alert>
  )
}
